import { getDoc } from "firebase/firestore/lite";

import { type FirestoreRefs } from "igfd-commons/src/firebase/refs";

export type UserApi = {
  // given the current user's uid, tells you if the user is an admin
  isAdminUser: (uid: string) => Promise<boolean>;
};

/**
 * An implementation of the UserApi that uses Firestore as the backend.
 */
export class FirestoreBackedUserApi implements UserApi {
  private readonly firestoreRefs: FirestoreRefs;

  constructor(firestoreRefs: FirestoreRefs) {
    this.firestoreRefs = firestoreRefs;
  }

  public async isAdminUser(uid: string): Promise<boolean> {
    // query the admin-users collection to check if the user has admin access to any restaurants
    const isAdinUser = await getDoc(this.firestoreRefs.adminUser(uid)).then(
      (doc) => doc.exists()
    );

    return isAdinUser;
  }
}
